import React from 'react';
import { Link } from 'react-router-dom';
import './ItemSummaryCard.css'; // We'll create this CSS file next
import { API_BASE_URL, IMAGE_BASE_URL } from '../urldata.js';



function ItemSummaryCard({ item, showDescription = true }) {
  const imageUrl = `${IMAGE_BASE_URL}/${item.id}-${item.thumbnail}.webp`
  const title = item.title || '';

  const description = item.description || '';
  const displayDescription = description.length > 200
    ? `${description.substring(0, 200)}...`
    : description;


  return (
    <Link
      to={`/itemlink/${item.id}`}
      className="item-summary-card" // Base styles (border, shadow, etc.) should be in ItemSummaryCard.css
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Ensures the card fills the height of its wrapper in Topcategories
      }}
    >
      <div
        className="item-summary-image-container"
      >
        <img src={imageUrl} alt={item.title || 'Item image'} className="item-summary-image" />
      </div>
      <div
        className="item-summary-details"
        style={{
          textAlign: 'left', // Original style
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1, // Allows this details section to take up available vertical space
          padding: '0 0.5rem' // Added for internal spacing; adjust if already handled by CSS
        }}
      >
        <h3 className="item-summary-title">{item.title}</h3>
        <p className="item-summary-price">
          Price: <b>{item.price !== undefined ? `${item.price} PKR` : 'N/A'}</b>
        </p>
        {showDescription && (
          <p className="item-summary-description">
            {displayDescription}
          </p>
        )}
      </div>
    </Link>
  );
}

export default ItemSummaryCard;